import React from 'react';
import s from './FooterMobile.scss';
import question from '../../../assets/images/icons/help-circle-cyan.svg';
import rightArrow from '../../../assets/images/icons/right-arrow-green.svg';
import { abtest  } from '../../../utils';


export const FooterMobile = ({abtestData, status}) => {
    return(
        <div className={s.mobileFooter}>
            <div className={s.faqContainer}>
                <img className = {s.questionIcon}  src = {question} alt = 'icono de pregunta'/>
                <a className={s.faq} href="/faqs">Preguntas Frecuentes</a> <br />
                <a className={s.faq} href="/faqs"><img className={s.rightArrowFaq} src={rightArrow} alt='flecha derecha'/></a>
            </div>
            {status < 30 &&
                <div className={s.creditContainer}>
                    <p className={s.changeForm}><a className={s.faq} href="/">{`Solicitar otro tipo de ${abtest(abtestData)}`}</a></p>
                    <a className={s.faq} href="/"><img className={s.rightArrow} src={rightArrow} alt='flecha derecha'/></a>
                </div>
            }
        </div>
    );
}

export default FooterMobile;
